import { LOCALES, UNIT_MAPPING, UNIT_SYSTEM } from "@zonar-ui/i18n";
import i18next from "i18next";

/**
 * Normalize a BCP-47 tag to the canonical casing used by `LOCALES`.
 * For example: 'en-ca' -> 'en-CA', 'EN' -> 'en'
 */
const canonicalizeTag = (tag: string) => {
	const [language, region] = tag.split("-");
	return region ? `${language.toLowerCase()}-${region.toUpperCase()}` : language.toLowerCase();
};

/**
 * Resolve the unit system from the browser's *raw* language tag.
 *
 * This deliberately does not use `currentLocale()`. That collapses the region subtag onto the six
 * locales we ship translations for (so 'en-CA' becomes 'en-US'), which is correct for text but
 * wrong for units: 'en-US' and 'en-CA' share a language and differ in measurement system.
 *
 * `UNIT_MAPPING` is the canonical table shared across Zonar apps. Tags it does not list
 * (for example 'en-LR', 'my-MM', 'pt-BR') fall back to Imperial, matching `@zonar-ui/i18n`.
 */
export const unitSystem = (): UNIT_SYSTEM =>
	UNIT_MAPPING[canonicalizeTag(i18next.language ?? "") as LOCALES] ?? UNIT_SYSTEM.IMPERIAL;
